import { TODO } from '@b2b/types/core';
import { ACMEUserConfigResponse } from '@b2b/types/user';
import { IInjectable } from '@uirouter/angularjs';
import { IPromise } from 'angular';
import { ApiService } from '../services/api/types';

export function UserConfigDataResolver(): IInjectable {
  return [
    'AuthService',
    'ApiService',
    function UserConfigData(AuthService: TODO, ApiService: ApiService): IPromise<{ data: ACMEUserConfigResponse }> {
      const user = AuthService.getCookie('user');

      if (user && user.id) {
        return ApiService.user.view(user.id) as TODO;
      }

      return Promise.resolve({ data: { success: false, user: {} } as ACMEUserConfigResponse });
    },
  ];
}
